<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="pt01">SECTION 1 <img alt="Image" src="images/img05_005.png"/><br/><strong>LEARNING TO SEE THE UNSEEN</strong></h2>
<p class="noindent"><a id="page_5"></a></p><a id="page_5">
</a><p class="noindent"><a id="page_5"></a><a id="page_6"></a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?d72b738a